import { render, staticRenderFns } from "./FilterAnnouncements.vue?vue&type=template&id=15a74f12"
import script from "./FilterAnnouncements.vue?vue&type=script&lang=js"
export * from "./FilterAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FilterAnnouncements.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DropdownList: require('/vercel/path0/components/DropdownList.vue').default})
